<template>
    <div
        ref="frame"
        class="iframe" />
</template>

<script>
import {debounce, uuid} from '@/utils/helpers';

export default {
    name: 'zeng-iframe',

    props: {
        source: {
            type: String,
            default: '',
            required: true
        }
    },

    data() {
        return {
            frame: null,
            uuid: uuid(),
        };
    },

    computed: {
        messages() {
            return {
                loaded: 'FRAME_LOADED_' + this.uuid,
                complete: 'FRAME_COMPLETE_' + this.uuid,
            };
        }
    },

    watch: {
        source() {
            return this.refresh();
        }
    },

    mounted() {
        setTimeout( () => {
            this.initialize();
        }, 50);
    },

    methods: {

        remove() {
            while (this.$el.firstChild) {
                this.$el.removeChild(this.$el.firstChild);
            }
        },

        initialize() {
            let frame = document.createElement('iframe');
            frame.setAttribute('crossorigin', 'anonymous');
            frame.setAttribute('target', '_parent');
            frame.setAttribute('sandbox', 'allow-forms allow-pointer-lock allow-popups allow-same-origin allow-scripts allow-top-navigation');
            frame.className = 'iframe__iframe iframe__iframe--inactive';
            this.frame = frame;
            this.setupFrame();
            this.setupEvents();
        },

        setupFrame() {
            if (this.source) {
                this.$refs.frame.appendChild(this.frame);
                const doc = this.frame.contentWindow.document;
                doc.open()
                    .write(`
                        <body onload="window.location.href='${this.source}'; parent.postMessage('${this.messages.loaded}', '*')"></body>
                        <script>
                            window.document.onreadystatechange = function () {
                                if(window.document.readyState === 'complete') {
                                    parent.postMessage('${this.messages.complete}', '*')
                                }
                            };
                        <\/script>`);
                doc.close();
            } else {
                console.error('Please provide src for the iframe component');
            }
        },

        setupEvents() {
            const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent',
                handler = window[eventMethod],
                messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';
            handler(messageEvent, event => {
                if (event.data === this.messages.loaded) {
                    //console.info('IFRAME LOADED');
                }
                if (event.data === this.messages.complete) {
                    this.frame.classList.remove('iframe__iframe--inactive');
                }
            }, false);
        },

        refresh() {
            debounce(() => {
                this.remove();
                this.initialize();
            }, 150)();
        }
    }
};
</script>

<style lang="scss">
.iframe {
    &__iframe {
        width: 100%;
        height: 100%;

        &--inactive {
            visibility: hidden;
            pointer-events: none;
        }
    }
}
</style>
